import React, { useState } from 'react'
import ButtonUC from '../../../components/buttonUC';
import { ShareAltOutlined } from '@ant-design/icons';
import { changeFormatdate } from '../../../utils/formatDate';
import SharedModal from '../../../components/sharedModal';
import config from '../../../config';
import { getHomeImageStorage } from '../../../utils/localStorage';
import { Tooltip } from 'antd';
import useHome from '../../home/context/useHome';

const ContentTitle = (props) => {
    const { job, handleClickApply } = props
    const [openModal, setOpenModal] = useState(false)
    const homeImage = getHomeImageStorage()
    const { cards } = useHome()

    const handleShare = (job) => {
        console.log('handleShare', job)
        setOpenModal(true)
    }

    const handleCancelModal = () => {
        setOpenModal(false)
    }

    const isMobile = window.innerWidth <= 768


    const getLogoFromBu = () => {
        if (job && job.buCode && cards && cards.length > 0) {
            const _card = cards.find(c => c.orgUnitCode === job.buCode)
            if (_card) return `${config.wfAttachFileEndPoint}/${_card.logo}`
        }
        return homeImage?.logo.includes('default-logo') ? homeImage?.logo : `${config.wfAttachFileEndPoint}/${homeImage?.logo}`
        // const _logo = orgUnitIdContext === '00' || !orgUnitIdContext ? homeLogo : `${config.wfAttachFileEndPoint}/${homeImage?.logo}`
        // return _logo || homeImage?.logo
    }

    const convertToDate = (val) => {
        let _date = val ? new Date(val) : new Date();
        _date.setHours(0, 0, 0, 0);
        return _date;
    };

    const _stratDate = convertToDate(job?.startDate)
    const _endDate = convertToDate(job?.endDate)
    const _currentDate = convertToDate()
    
    return (
        <>
            <div className='content-title '>
                <div className="content-title-top">
                    <div className="logo-jobDetail flex">
                        <div className="div-image">
                            <img className='margin-auto'
                                // src={homeImage?.logo.includes('default-logo') ? homeImage?.logo : `${config.wfAttachFileEndPoint}/${homeImage?.logo}`}
                                src={getLogoFromBu()}
                                alt={`${job?.positionManageName ?? ''} ${job?.positionCareerName ?? ''} ${job?.empLevel ?? ''} ${job?.wardName ?? ''} ${job?.divisionName ?? ''} ${job?.departmentName ?? ''} ${job?.buName ?? ''}`} />
                        </div>
                        <div className="div-title">
                            <Tooltip trigger={isMobile ? 'click' : 'hover'} title={`${job?.positionManageName ?? ''} ${job?.positionCareerName ?? ''} ${job?.empLevel ?? ''} ${job?.wardName ?? ''} ${job?.divisionName ?? ''} ${job?.departmentName ?? ''} ${job?.buName ?? ''}`}>
                                <div className="title line-clamp-2">
                                    {`${job?.positionManageName ?? ''} ${job?.positionCareerName ?? ''} ${job?.empLevel ?? ''}`}
                                </div>
                                <div className="title line-clamp-2 mb-4">
                                    {`${job?.wardName ?? ''}  ${job?.divisionName ?? ''} ${job?.departmentName ?? ''} ${job?.buName ?? ''}`}
                                </div>
                            </Tooltip>
                            {!isMobile &&
                                <div className="content">
                                    <div className="div-address flex">
                                        {/* <div className="icon-address mr-1 flex justify-center items-center">
                                            <MdLocationPin className='fa-location' />
                                        </div>
                                        <div className="address">{job?.address}</div> */}
                                    </div>
                                    {job.isExtend === false &&
                                        <div className="div-detail flex">
                                            <div className="open flex mr-4">
                                                <div className="label">เปิดรับสมัคร</div>
                                                <div className="open-date pl-1 ">{changeFormatdate(job?.startDate)}</div>
                                            </div>
                                            <div className="close flex ">
                                                <div className="label">ปิดรับสมัคร</div>
                                                <div className="close-date pl-1 ">{job?.isNoEndDate === true ? 'ไม่กำหนด' : changeFormatdate(job?.endDate)}</div>
                                            </div>
                                        </div>}
                                    {job.isExtend === true &&
                                        <div className="div-detail flex">
                                            <div className="open flex mr-4">
                                                <div className="label">ขยายการรับสมัคร</div>
                                                <div className="label ml-4">วันที่</div>
                                                <div className="open-date pl-1 ">{changeFormatdate(job?.startDate)}</div>
                                            </div>
                                            <div className="close flex ">
                                                <div className="label">ถึง</div>
                                                <div className="close-date pl-1 ">{job?.isNoEndDate === true ? 'ไม่กำหนด' : changeFormatdate(job?.endDate)}</div>
                                            </div>
                                        </div>}
                                </div>
                            }
                        </div>
                    </div>
                    {isMobile &&
                        <div className="content">
                            <div className="div-address flex">
                                {/* <div className="icon-address mr-1 flex justify-center items-center">
                                    <MdLocationPin className='fa-location' />
                                </div>
                                <div className="address">{job?.address}</div> */}
                            </div>
                            {job.isExtend === false &&
                                <div className="div-detail flex">
                                    <div className="open flex mr-4">
                                        <div className="label">เปิดรับสมัคร</div>
                                        <div className="open-date pl-1 ">{changeFormatdate(job?.startDate)}</div>
                                    </div>
                                    <div className="close flex ">
                                        <div className="label">ปิดรับสมัคร</div>
                                        <div className="close-date pl-1 ">{job?.isNoEndDate === true ? 'ไม่กำหนด' : changeFormatdate(job?.endDate)}</div>
                                    </div>
                                </div>}
                            {job.isExtend === true &&
                                <div className="div-detail flex">
                                    <div className="open flex mr-4">
                                        <div className="label">ขยายการรับสมัคร</div>
                                        <div className="label ml-4">วันที่</div>
                                        <div className="open-date pl-1 ">{changeFormatdate(job?.startDate)}</div>
                                    </div>
                                    <div className="close flex ">
                                        <div className="label">ถึง</div>
                                        <div className="close-date pl-1 ">{job?.isNoEndDate === true ? 'ไม่กำหนด' : changeFormatdate(job?.endDate)}</div>
                                    </div>
                                </div>}
                        </div>
                    }
                </div> 
                {job?.status && job?.status !== 'draft' && 
                (job?.isPublish && (_stratDate <= _currentDate && ((_endDate >= _currentDate) || !job?.endDate))) &&
                    <div className="content-title-bottom  flex items-center justify-end">
                        <ButtonUC className='btn-apply btn-custom mr-4' onClick={() => handleClickApply()}>สมัครงาน</ButtonUC>
                        <div className='cursor-pointer' onClick={() => handleShare(job)}>
                            <ShareAltOutlined className='icon-footer' />
                        </div>
                    </div>
                }
            </div>

            {openModal &&
                <SharedModal
                    data={job}
                    open={openModal}
                    handleCancel={handleCancelModal}
                />}
        </>
    )
}

export default ContentTitle